import { render, staticRenderFns } from "./CryptoCoffeeMug.vue?vue&type=template&id=b15d311e"
import script from "./CryptoCoffeeMug.vue?vue&type=script&lang=js"
export * from "./CryptoCoffeeMug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports